import { useAlert } from './AlertContext.jsx';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import React from 'react';

export function AlertMessage() {
    const { alert, closeAlert } = useAlert();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;  // Do nothing if the snackbar is clicked away
        }
        closeAlert();  // Close the alert using the method from context
    };

    return (
        <Snackbar
            open={alert.show}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <Alert
                onClose={handleClose}
                severity={alert.severity}
                variant="filled"
                sx={{ width: '100%', whiteSpace: 'pre-line' }}
            >
                {alert.message}
            </Alert>
        </Snackbar>
    );
}
